// Module
var code = "<div class=\"row\">\r\n\r\n    <div class=\"col-md-8 col-md-offset-2\">\r\n\r\n        <h2 data-bind=\"restext: 'PasswordResetProcessChanged'\"></h2>\r\n        <p data-bind=\"restext: 'PasswordResetProcessMessage'\"></p>\r\n        <p data-bind=\"restext: 'PasswordResetProcessInstructions'\"></p>\r\n\r\n    </div>\r\n</div>\r\n";
// Exports
export default code;